'use strict';
import React, { Component } from 'react';
import Header from './Header.jsx';
import Body from './Body.jsx';
import Footer from './Footer.jsx';
import { createForm } from 'rc-form';

class Cuenta extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { data, executionContext } = this.props;

        const funciones = {
            changeInput: this.props.changeInput,
            selectCombo: this.props.selectCombo,
            guardarNovedad: this.props.guardarNovedad,
            mostrarComponente: this.props.mostrarComponente,
            estadoEdicion: this.props.estadoEdicion,
            guardarCampo: this.props.guardarCampo,
            guardarNovedades: this.props.guardarNovedades,
            cancelar: this.props.cancelar,
            changeEditView: this.props.changeEditView,
            changeText: this.props.changeText,
            mostrarModal: this.props.mostrarModal,
            actualizarNovedadEstado: this.props.actualizarNovedadEstado,
            actualizarNovedadEstados: this.props.actualizarNovedadEstados,
            openModalBajaCuenta: this.props.openModalBajaCuenta,
            closeModalBajaCuenta: this.props.closeModalBajaCuenta,
            valorTextArea: this.props.valorTextArea,
            valorSelect: this.props.valorSelect,
            realizarBajaCuentaTarjeta: this.props.realizarBajaCuentaTarjeta,
            changeCheckSolicitarCaidaCuotas: this.props.changeCheckSolicitarCaidaCuotas
        }

        return <form id="cuenta" name="cuenta" className="top-separator-xs left-separator-xs" method="POST">
            <div className="container-fluid">
                <Header data={data} />
                <Body data={data}
                    executionContext={executionContext}
                    form={this.props.form}
                    funciones={funciones} />
                <br />
                <Footer data={data} />
            </div>
        </form>
    }

}
export default createForm()(Cuenta);